import React, { Component } from 'react';
import { dataLayerPush } from '../../components/Global/helpers';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import styles from './DealerHome.module.css';
import classNames from 'classnames';
import UpperCard from './UpperCard';
import LowerCard from './LowerCard';
import { getBrandContent } from '../../components/BrandingWhiteLabel/BrandContent';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';
import SnackBarAlert from '../../components/shared/SnackBar/SnackBarAlert';
import moment from 'moment';
import { SessionContext } from '../../context/SessionContext';
import LegacyAutoLogin from '../../components/LegacyAutoLogin';
import StaplesProgramLogo from '../../assets/images/Vendor/Staples/staples-program-logo.svg';
import { isStaplesClient } from '../../lib/util';
import PageLoading from '../../components/shared/PageLoading/PageLoading';

export class DealerHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            enrolledToCampaign: 'UNENROLLED',
            eligibleForCampaign: false,
            dealerProfile: [],
            activeContractCount: 0,
            pendingPaymentCount: 0,
            incompleteSaleCount: 0,
            advantageProgramName: '',
            paymentHistoryCount: 0,
            serviceRequestCount: 0,
            claimCount: 0,
            reportType: { id: 0, title: '', type: '' },
            reportTypeList: [],

            tabId: this.props.tabId === undefined ? 0 : this.props.tabId,

            formData: {
                dealerId: '',
                dealerBrand: '',
                claimsOnly: false,
                dateTime: '',
                hash: '',
                snUserName: 'VendorPortal',
                isAdmin: false,
                isDraftDocAdmin: false,
                accountID: '',
                sorg: ''
            },

            url: '',

            tabState: {
                activeTab: 2 // for the profile component
            },
            showSnackBar: false,
            cardSettings: [],
            cardsLoaded: false,
            pageUpdatesExecuted: false,
            pageStatsLoaded: false
        };

        this.handleUnload = this.handleUnload.bind(this);
    }

    loadTabList = () => {
        // add your tabs here.
        let reportTypeList = this.state.reportTypeList;
        reportTypeList.push(
            { tabId: 1, title: 'Reports', type: 'activecontracts', tabType: 'reports' },
            { tabId: 2, title: 'Reports', type: 'pendingcontracts', tabType: 'reports' },
            { tabId: 3, title: 'Reports', type: 'incompletesales', tabType: 'reports' },
            { tabId: 4, title: 'Reports', type: 'contracts', tabType: 'reports' },
            { tabId: 5, title: 'Sale Entry', type: 'orderinfo', tabType: 'orderinfo' },
            { tabId: 6, title: 'Profile', type: 'profile', tabType: 'profile' },
            { tabId: 7, title: 'Resources', type: 'resources', tabType: 'resources' },
            { tabId: 8, title: 'Profile', type: 'payment', tabType: 'profile' },
            { tabId: 9, title: 'Reports', type: 'servicerequest', tabType: 'reports' },
            { tabId: 10, title: 'Reports', type: 'claims', tabType: 'reports' },
            { tabId: 11, title: 'Reports', type: 'paymenthistory', tabType: 'reports' },
            { tabId: 12, title: 'Plan Pricing', type: 'pricing', tabType: 'pricing' }
        );
        this.setState({ reportTypeList: reportTypeList });
    };

    componentWillMount() {
        this.loadTabList();
        this.init();

        const { cardsLoaded } = this.state;
        if (!cardsLoaded) {
            this.getPageSettings();
        } else {
            this.getPageDetails();
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleUnload);
        dataLayerPush('Pageview', {
            pageTitle: 'Dashboard',
            pagePath: '/dashboard'
        });

        const { cardsLoaded } = this.state;
        if (!cardsLoaded) {
            this.getPageSettings();
        } else {
            this.getPageDetails();
        }
    }

    componentDidUpdate() {
        const { cardsLoaded } = this.state;
        if (!cardsLoaded) {
            this.getPageSettings();
        }
    }

    handleUnload(e) {
        const sessionContext = this.context;
        sessionContext.logout();
    }

    setShowSnackBar(flag) {
        this.setState({
            showSnackBar: flag
        });
    }

    loadTab = (tabId, activeProfileTab, state) => {
        const { updateReportTab } = this.context;
        try {
            if (tabId === -1) {
                return;
            }

            const tabs = this.state.reportTypeList;
            const tab = tabs.find((x) => {
                return x.tabId === tabId;
            });

            //update report type to add subtab based on type
            updateReportTab({
                tabId: tab.tabId,
                tabType: tab.tabType,
                reportType: tab.type
            });

            if (tab) {
                const { context } = this;
                if (tab.tabType === 'reports') {
                    context.pendingReportTrack = {
                        selecteContractId: [],
                        selecteContractRows: [],
                        contractType: '',
                        pendingBackFlag: context.isExternalLogin ? context.pendingReportTrack.pendingBackFlag : false
                    };
                }

                //reset session for component coming from non report screen
                if (tab.tabType === 'orderinfo') {
                    context.setSourcePage({
                        sourcePage: {
                            pageId: 'Sale Entry',
                            targetTab: 1,
                            contracts: ''
                        }
                    });
                }
                if (activeProfileTab === 'resource') {
                    context.tabDispatch('ADD_TAB', {
                        title: 'Resources',
                        tabType: 'resources',
                        activeSubtab: 1,
                        currentResourceTab: 3,
                        activeResourceTab: { data: 'marketingMaterials', display: 'Marketing Materials' }
                    });
                } else {
                    context.tabDispatch('ADD_TAB', {
                        title: tab.title,
                        reportType: tab.type,
                        tabType: tab.tabType,
                        activeProfileTab,
                        state: state
                    });
                }
            }
        } catch (e) {
            console.log('Unable to load reports.', e);
        }
    };

    init = async () => {
        var isResetPasswordSuccess = this.context.getIsResetPasswordSuccess();
        isResetPasswordSuccess == 'true' ? this.setShowSnackBar(true) : this.setShowSnackBar(false);

        var dealerProfile = this.context.getProfile();

        if (dealerProfile?.status !== null) {
            this.setState({
                eligibleForCampaign: dealerProfile?.isAdvantageEligible,
                dealerProfile: dealerProfile,
                dealerProfileLoaded: true
            });
        }

        this.setState({ pageUpdatesExecuted: false, pageStatsLoaded: false });

        let ctxt = this.context;

        if (ctxt) {
            ctxt.resetHomePageFlagStats();

            this.getPageUpdates(ctxt);

            if (ctxt.isExternalLogin !== undefined) {
                if (ctxt.isExternalLogin) {
                    let tabList = this.state.reportTypeList;
                    let targetTab = tabList.find((x) => x.type === ctxt.targetTab);

                    if (targetTab !== undefined) {
                        if (targetTab.type == 'payment') {
                            // let statePassed = { activeTab: 2 };
                            this.loadTab(targetTab.tabId, 2);
                        } else if (ctxt.targetTab.toLowerCase() === 'profile') {
                            // let statePassed = { activeTab: 2 };
                            this.loadTab(targetTab.tabId, 2);
                        } else {
                            if (
                                ctxt.targetTab.toLowerCase() === 'contracts'
                                && ctxt.targetTabFilter.toLowerCase() === 'pending'
                            ) {
                                ctxt.pendingReportTrack.pendingBackFlag = true;
                            }

                            this.loadTab(targetTab.tabId);
                        }

                        //this.loadTab(targetTab.tabId);
                        this.consumeToken(ctxt.token);

                        ctxt.dangerouslyUpdateAuthState({
                            isExternalLogin: false,
                            targetTab: '',
                            token: '',
                            targetTabFilter: ''
                        });
                        // ctxt.isExternalLogin = false;
                    }
                }
            }
        }
    };

    getAdvantageCard = () => {
        const { accountName, homePageDetails } = this.context;
        const advantage = { amount: 'Enrolled', category: 'Pending Campaign' };
        const advProgramName = getBrandContent(accountName).advantageProgramName;
        const { enrolledToCampaign } = homePageDetails;

        switch (enrolledToCampaign) {
            case 'ENROLLED_ACTIVE': {
                advantage.amount = advProgramName;
                advantage.category = 'Active Campaign';
                break;
            }
            case 'ENROLLED_PENDING': {
                advantage.amount = 'Enrolled';
                advantage.category = 'Pending Campaign';
                break;
            }
            case 'ENROLLED_NO_CAMPAIGN': {
                advantage.amount = advProgramName;
                advantage.category = 'No Active Campaign';
                break;
            }
            case 'UNENROLLED': {
                advantage.amount = 'Enroll Now';
                advantage.category = advProgramName;
                break;
            }
            default:
                break;
        }

        return (
            <UpperCard
                onCardClick={() => {
                    this.loadTab(6, 2);
                }}
                image='advantage'
                isAdvatageCard={true}
                {...advantage}
            />
        );
    };

    handleAdvantageClick = () => {
        const dealerId = this.state.dealerProfile?.dealerId;

        if (dealerId !== undefined) this.loadTab(6, { activeTab: 2 });
        /*this.setState({ redirectInvoked: true });*/
    };

    consumeToken = async (token) => {
        var res = await fetch(`token/ConsumeToken/${token}`);

        if (res.status === 200) {
            return true;
        } else {
            return false;
        }
    };

    getUpperCardColumnSize = (columnLength, screenSize) => {
        if (screenSize === 'lg') {
            //Large screen sizes
            if (columnLength === 2) {
                return '6';
            } else if (columnLength === 3) {
                return '4';
            } else if (columnLength === 4) {
                return '3';
            }
        } else if (screenSize === 'sm') {
            //Small screen sizes
            if (columnLength === 2) {
                return '6';
            } else if (columnLength === 3) {
                return '4';
            } else if (columnLength === 4) {
                return '3';
            }
        }
    };

    plotColumns = (columns, accountName) => {
        const { homePageDetails } = this.context;
        let {
            activeContractCount,
            pendingPaymentCount,
            incompleteSaleCount,
            paymentHistoryCount,
            serviceRequestCount,
            claimCount,
            eligibleForCampaign
        } = homePageDetails;

        const tempColumn = {
            activeContractCount,
            pendingPaymentCount,
            incompleteSaleCount,
            paymentHistoryCount,
            serviceRequestCount,
            claimCount,
            eligibleForCampaign
        };

        eligibleForCampaign = eligibleForCampaign ?? true;

        const columnLength = columns?.filter((col) => col?.visible === true)?.length;
        if (columnLength == 0) return;

        let newColumns = columns?.map((currentColumn) => {
            let tabId = currentColumn?.tabId;
            tabId = !isNaN(tabId) ? parseInt(tabId) : -1;

            return (
                <>
                    {currentColumn?.cardType?.toLowerCase() === 'uppercard' && currentColumn?.visible && (
                        <Col
                            className={styles.upperCardWrapper}
                            sm={this.getUpperCardColumnSize(columnLength, 'sm')}
                            lg={this.getUpperCardColumnSize(columnLength, 'lg')}
                        >
                            {currentColumn?.title.toLowerCase() !== 'advantagecard' && (
                                <UpperCard
                                    onCardClick={() => {
                                        this.loadTab(tabId);
                                    }}
                                    amount={
                                        this.state[currentColumn?.title] !== tempColumn[currentColumn?.title]
                                            ? tempColumn[currentColumn?.title]
                                            : this.state[currentColumn?.title]
                                    }
                                    category={currentColumn?.description}
                                    image={currentColumn?.image}
                                    isPendingPayment={currentColumn?.isPendingPayment}
                                />
                            )}
                            {currentColumn?.title.toLowerCase() === 'advantagecard' && this.getAdvantageCard()}
                        </Col>
                    )}
                    {currentColumn?.cardType?.toLowerCase() === 'lowercard' && currentColumn?.visible && (
                        <Col
                            xs='12'
                            md='6'
                            lg='3'
                        >
                            <div
                                onClick={() => {
                                    this.loadTab(tabId);
                                }}
                                className='mb-3'
                            >
                                <LowerCard
                                    cardTitle={currentColumn?.title}
                                    description={currentColumn?.description}
                                    bgColor={currentColumn?.bgColor}
                                    isManageClaims={currentColumn?.isManageClaims}
                                >
                                    <BrandedIcon
                                        accountName={accountName}
                                        iconType={currentColumn?.image}
                                    />
                                </LowerCard>
                            </div>
                        </Col>
                    )}
                </>
            );
        });

        return newColumns;
    };

    loadCardSettings = (cards, accountName) => {
        if (cards?.length > 0) {
            var cards = cards?.map((row) => {
                return (
                    <>
                        <Row className='multiColWrapper'>
                            {this.plotColumns(
                                row.cardDetails.sort(function (a, b) {
                                    return parseInt(a.tabId) - parseInt(b.tabId);
                                }),
                                accountName
                            )}
                        </Row>
                    </>
                );
            });

            return cards;
        }
    };

    getPageUpdates = (context) => {
        if (context) {
            const {
                homePageDetails: {
                    advantageProgramName,
                    enrolledToCampaign,
                    activeContractCount,
                    incompleteSaleCount,
                    pendingPaymentCount,
                    incompleteDeletedSaleCount,
                    serviceRequestCount,
                    claimCount
                }
            } = context;

            this.setState({
                advantageProgramName,
                enrolledToCampaign,
                activeContractCount,
                incompleteSaleCount,
                pendingPaymentCount,
                incompleteDeletedSaleCount,
                serviceRequestCount,
                claimCount
            });
        }
    };

    getPageSettings = () => {
        let ctxt = this.context;

        if (ctxt) {
            const cardSettings = ctxt.getCardSettings();
            console.log(cardSettings, 'Card Settings');

            if (cardSettings) {
                this.setState({
                    cardSettings: cardSettings?.cards,
                    cardsLoaded: true
                });

                this.getPageUpdates(ctxt);
            }
        }
    };

    getPageDetails = () => {
        let { pageUpdatesExecuted, pageStatsLoaded } = this.state;

        if (!pageUpdatesExecuted) {
            this.context.getPageDetails();
            this.setState({ pageUpdatesExecuted: true });
        } else {
            if (this.context.allHomePageFlagStatsUpdated() && !pageStatsLoaded) {
                this.getPageUpdates(this.context);
                this.setState({ pageStatsLoaded: true });
            }
        }
    };

    render() {
        const { cardSettings, cardsLoaded, pageUpdatesExecuted, pageStatsLoaded } = this.state;
        const { accountName, homePageDetails } = this.context;
        const accountNameToLower = accountName.toLowerCase();
        const benefits = getBrandContent('advantageBenefits')?.[accountNameToLower]?.homeScreen;
        const promoBenefits = getBrandContent('advantageBenefits')?.[accountNameToLower]?.promoScreen;
        const { enrolledToCampaign, eligibleForCampaign } = homePageDetails;
        const isStaples = isStaplesClient(accountName);

        if (!cardsLoaded && !pageUpdatesExecuted) {
            return <PageLoading />;
        }

        return (
            <Container className={classNames('contentWrapper', styles.dealerHm)}>
                <h1>{`Welcome to ${isStaples ? 'Staples ' : ''}${getBrandContent(accountName).programName}`}</h1>
                <p className={styles.instructionText}>Choose an option to get started</p>
                {accountNameToLower === 'lennox' && (
                    <Card>
                        <CardBody className={styles.benefitsList}>
                            <Row className='m-0 align-items-center'>
                                <Col
                                    lg='10'
                                    className='p-0'
                                >
                                    <h2 className={styles.lennoxBanner}>New Refrigerant Coverage Options Available</h2>
                                    <h6>
                                        Manage the volatility of refrigerant prices amidst 2025 government regulations
                                    </h6>
                                    <ul className={styles.promosList}>
                                        {promoBenefits && promoBenefits.map((b, i) => <li key={i}>{b}</li>)}
                                    </ul>
                                </Col>
                                <Col className={styles.joinBtn}>
                                    <button
                                        className='btn-primary'
                                        onClick={() => {
                                            this.loadTab(7, 'resource');
                                        }}
                                    >
                                        Learn More
                                    </button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                )}
                {enrolledToCampaign === 'UNENROLLED'
                    && eligibleForCampaign
                    && accountNameToLower !== 'ge'
                    && accountNameToLower !== 'lennox' && (
                        <Card>
                            <CardBody className={styles.benefitsList}>
                                <Row className='m-0 align-items-center'>
                                    <Col
                                        lg='10'
                                        className='p-0'
                                    >
                                        <h2>{`${getBrandContent(accountName).advantageProgramName} Program Benefits`}</h2>
                                        <ul className='row m-0'>
                                            {benefits && benefits.map((b, i) => <li key={i}>{b}</li>)}
                                        </ul>
                                    </Col>
                                    {!isStaples && (
                                        <Col className={styles.joinBtn}>
                                            <button
                                                className='btn-primary'
                                                onClick={() => {
                                                    this.loadTab(6, 2);
                                                }}
                                            >
                                                Join
                                            </button>
                                        </Col>
                                    )}
                                    {isStaples && (
                                        <Col className={styles.joinBtn}>
                                            <img
                                                src={StaplesProgramLogo}
                                                alt='Staples logo'
                                                className={styles.joinBtn}
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </CardBody>
                        </Card>
                    )}
                {cardsLoaded && this.loadCardSettings(cardSettings, accountName)}
                {this.state.showSnackBar && (
                    <SnackBarAlert
                        content={'Password updated successfully!'}
                        showSnackBar={true}
                        onClose={() => this.setShowSnackBar(false)}
                    />
                )}
            </Container>
        );
    }
}

DealerHome.contextType = SessionContext;
